import React from 'react';
import styles from '../css/Main.css';
import Navigation from '../components/Navigation.js';

export default function Main() {
  return (
    <div className={styles.containerHome}>
      <div className={styles.header2}>
        <p className={styles.titleleft2}>Hanna Schneider</p>
        <p className={styles.titleright2}>Keramik</p>
      </div>
      <Navigation />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Home.js